function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { i18n } from 'invision-core';
var DEFAULT_MAX_VISIBLE_CHARACTERS = 500;
var RemarkController = /*#__PURE__*/function () {
  function RemarkController($ngRedux) {
    _classCallCheck(this, RemarkController);
    this.$ngRedux = $ngRedux;
    this.disconnectRedux = null;
  }
  return _createClass(RemarkController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.maxVisibleCharacters = this.maxVisibleCharacters || DEFAULT_MAX_VISIBLE_CHARACTERS;
      this.displayMore = true;
      this.actions = [{
        title: i18n.translate(CustomerCareLocaleKeys.REMARK.EDIT),
        action: function action() {
          return _this.editRemark();
        }
      }];
      this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
    }
  }, {
    key: "$onChanges",
    value: function $onChanges() {
      this.fullyVisible = this.remark.Body.length < this.maxVisibleCharacters;
      this.displayMore = !this.fullyVisible;
      this.setVisibilityOfFullMessage(this.displayMore);
      this.hasBeenModified = this.remark.Modified !== this.remark.Created;
    }
  }, {
    key: "handleActionSelection",
    value: function handleActionSelection(_ref) {
      var action = _ref.item.action;
      action();
    }
  }, {
    key: "toggleDisplayMore",
    value: function toggleDisplayMore() {
      var displayMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.displayMore;
      this.displayMore = !displayMore;
      this.setVisibilityOfFullMessage(this.displayMore);
    }
  }, {
    key: "setVisibilityOfFullMessage",
    value: function setVisibilityOfFullMessage(displayMore) {
      this.visibleMessage = !displayMore || this.fullyVisible ? this.remark.Body : "".concat(this.remark.Body.substr(0, this.maxVisibleCharacters), "...");
    }
  }, {
    key: "editRemark",
    value: function editRemark() {
      this.onEditRemark({
        remark: this.remark
      });
    }
  }, {
    key: "dateLabelKey",
    get: function get() {
      return this.hasBeenModified ? this.CustomerCareLocaleKeys.REMARK.MODIFIED : this.CustomerCareLocaleKeys.REMARK.CREATED;
    }
  }, {
    key: "moreOrLessKey",
    get: function get() {
      return this.displayMore ? CustomerCareLocaleKeys.MORE : CustomerCareLocaleKeys.LESS;
    }
  }]);
}();
export default {
  bindings: {
    hasAdminAccess: '<',
    remark: '<',
    maxVisibleCharacters: '<',
    onEditRemark: '&'
  },
  template: require('./remark.html'),
  controller: RemarkController,
  controllerAs: 'Remark'
};